import Screen from './screen';
import template from './templates/login.html';
import widgetLoginChecker from './widgetLoginChecker.js';
import { LoadingElement } from './loadingElement';
export class LoginScreen extends Screen {
    constructor(uic) {
        super("login", uic);
        /**
        * Prefill login form if data is available
        * @param {*} data object with user information
        */
        this.setLoginData = (data) => {
            let firstname = data.firstname;
            let lastname = data.lastname;
            let email = data.email;
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            this.elements['loginFirstName'].val(firstname);
            this.elements['loginLastName'].val(lastname);
            this.elements['loginEmail'].val(email);
            if (!!this.elements['loginFirstName'].val() &&
                !!this.elements['loginLastName'].val() &&
                !!this.elements['loginEmail'].val() &&
                regex.test(this.elements['loginEmail'].val())) {
                this.elements['loginSubmitButton'].removeAttr('disabled');
            }
        };
        this.elements = {};
    }
    show(options) {
        let agentTarget = "unknown";
        if (options !== undefined) {
            let agentTarget = options;
        }
        this.uic.setOnboarding(agentTarget);
        // attach login checker
        this.elements['login'].show();
        this.elements['loginSubmitButton'].css({ display: 'block' });
        this.elements['loader'].hide();
        this.setLoginData(this.uic.cachingService);
        this.uic.hideDownloadIcon();
        this.uic.toggleChatWindowVisibility(true);
    }
    hide() {
        this.elements['login'].hide();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.elements['login'] = $('#cbot-login-chatwindow');
        this.elements['loginFirstName'] = $('.js-login-input-firstname');
        this.elements['loginLastName'] = $('.js-login-input-lastname');
        this.elements['loginEmail'] = $('.js-login-input-email');
        this.elements['loginSubmitButton'] = $('.js-login-btn-submit');
        this.elements['login'].data('loginChecker', new widgetLoginChecker(this));
        this.elements['loginContent'] = $('#cbot-login-chatwindow').find('.cbot-screen__content');
        this.elements['loader'] = new LoadingElement(this.elements['loginContent'], "login");
        // -----------------------------------------------------------------------------
        //                          USER LOGIN HANDLING
        // -----------------------------------------------------------------------------
        this.elements['loginSubmitButton'].on('click', $.proxy(() => {
            // get the loginChecker and ask if permitted
            let lc = this.elements['login'].data('loginChecker');
            if (lc && lc.click()) {
                // Save relevant information to cache and evaluate state
                this.uic.cachingService.firstname = this.elements['loginFirstName'].val();
                this.uic.cachingService.lastname = this.elements['loginLastName'].val();
                this.uic.cachingService.email = this.elements['loginEmail'].val();
                this.elements['loginSubmitButton'].hide();
                this.elements['loader'].show();
                this.uic.widget.startChat();
                this.uic.widget.track("chat", "chat_start", "login_form");
            }
        }, this));
    }
    resizeEvent() {
    }
    ;
}
